import { head } from "@utils/array";
import { SalesIncentiveType } from "@utils/enums";
import { PromoLabel, PromoLabelType } from "../../@types/service/shared";

export type PromotionForPromoLabel = {
    promotionType?: SalesIncentiveType | null;
    promotionValue: number | null;
    promotionPercent?: number | null;
    promotionPercentage?: number | null;
};

export type SalesIncentiveForPromoLabel = {
    type: SalesIncentiveType;
    order: number;
};

const getFormattedCashBackValue = (promotions?: PromotionForPromoLabel[]) => {
    const cb = promotions?.find(
        p => p.promotionType === SalesIncentiveType.Cashback,
    );

    if (cb?.promotionValue) {
        return `${cb.promotionValue}€`;
    }
    if (cb?.promotionPercent) {
        return `${cb.promotionPercent}%`;
    }
    if (cb?.promotionPercentage) {
        return `${cb.promotionPercentage}%`;
    }
};

const getPromoLabel = (
    salesIncentives: SalesIncentiveForPromoLabel[],
    discountPercentage: number,
    promotions?: PromotionForPromoLabel[],
): PromoLabel | undefined => {
    const highestPrioIncentive = head(
        salesIncentives.sort((a, b) => a.order - b.order),
    );

    if (!highestPrioIncentive) {
        return undefined;
    }

    const discountIncentives = [
        SalesIncentiveType.ActiePrijs,
        SalesIncentiveType.FolderPrijs,
        SalesIncentiveType.CombinatiePrijs,
        SalesIncentiveType.OutletPrijs,
        SalesIncentiveType.KortingProcent,
    ];

    if (
        discountIncentives.some(
            incentive => incentive === highestPrioIncentive.type,
        )
    ) {
        return {
            salesIncentiveType: highestPrioIncentive.type,
            promoLabeLType: PromoLabelType.Promo,
            formattedPromotionValue: discountPercentage
                ? `${Math.floor(discountPercentage)}%`
                : undefined,
        };
    }

    switch (highestPrioIncentive.type) {
        case SalesIncentiveType.EveryDayLowPrice:
            return {
                salesIncentiveType: highestPrioIncentive.type,
                promoLabeLType: PromoLabelType.EveryDayLowPrice,
            };
        case SalesIncentiveType.GratisTransport:
            return {
                salesIncentiveType: highestPrioIncentive.type,
                promoLabeLType: PromoLabelType.FreeTransport,
            };
        case SalesIncentiveType.Cashback:
            return {
                salesIncentiveType: highestPrioIncentive.type,
                promoLabeLType: PromoLabelType.Cashback,
                formattedPromotionValue: getFormattedCashBackValue(promotions),
            };
        case SalesIncentiveType.GratisArtikel:
            return {
                salesIncentiveType: highestPrioIncentive.type,
                promoLabeLType: PromoLabelType.FreeArticle,
            };
    }

    return undefined;
};

export { getPromoLabel };
